// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
import { router } from './config';
import api from './api';
import permission from './permission';
import 'default-passive-events';
import ElementUI from './element-ui-components';
import globalComponents from './global-components';
import '@/utils/protocolcheck'

Vue.config.productionTip = false;
//注册element-ui组件
ElementUI();
//注册全局子组件
globalComponents();
Vue.prototype.$bus = new Vue();
Vue.prototype.$api = api;

//百度统计
router.afterEach((to, from, next) => {
  setTimeout(() => {
    var _hmt = _hmt || [];
    (function () {
      var hm = document.createElement('script');
      hm.src = 'https://hm.baidu.com/hm.js?5b0a5bee741be5864bd9a61a7a7c4d00';
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(hm, s);
    })();
  }, 0);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App,
  },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js